/* Messages d'erreur du portail, rédigés pour le client.

   Règle : le texte renvoyé par un service n'est jamais affiché tel quel. Il
   peut être technique (exception Java), en anglais, ou parler de « quête » et
   de « token ». Le portail choisit son message d'après le code HTTP. Seule
   exception, ailleurs : le refus 429 de la génération de mission, dont le
   texte est écrit pour le client (pages/NewMission.tsx). */

const RESEAU = 'Impossible de joindre Tribe. Vérifiez votre connexion puis réessayez.';

const statut = (err: unknown): number | null => {
  const e = err as { response?: { status?: number } } | null;
  return e?.response?.status ?? null;
};
const sansReponse = (err: unknown) => !(err as { response?: unknown } | null)?.response;

export function messageConnexion(err: unknown): string {
  if (sansReponse(err)) return RESEAU;
  switch (statut(err)) {
    case 401: return 'Adresse email ou mot de passe incorrect.';
    case 403: return "Votre adresse email n'est pas encore confirmée. Ouvrez le lien reçu par email, ou demandez-en un nouveau ci-dessous.";
    case 429: return 'Trop de tentatives. Patientez quelques minutes avant de réessayer.';
    default:  return 'La connexion a échoué. Réessayez dans quelques minutes.';
  }
}

export function messageInscription(err: unknown): string {
  if (sansReponse(err)) return RESEAU;
  switch (statut(err)) {
    case 409: return 'Un compte existe déjà avec cette adresse. Connectez-vous, ou utilisez « Mot de passe oublié ».';
    case 400: return 'Certaines informations sont incomplètes ou invalides. Vérifiez le formulaire.';
    case 403: return "Cette invitation ne permet pas de créer le compte : elle n'est pas reconnue, ou elle a été envoyée à une autre adresse. Demandez une nouvelle invitation à contact@tribe.sn.";
    case 410: return "Cette invitation n'est plus valable : elle a expiré, a déjà servi ou a été annulée. Demandez-en une nouvelle à contact@tribe.sn.";
    default:  return "Le compte n'a pas pu être créé. Réessayez dans quelques minutes, ou écrivez à contact@tribe.sn.";
  }
}

export function messageSignatureDevis(err: unknown): string {
  if (sansReponse(err)) return RESEAU;
  switch (statut(err)) {
    case 400:
    case 409: return "Ce devis ne peut pas être signé tel quel : il a peut-être été remplacé par un devis plus récent, ou il est déjà signé. Rechargez la page pour voir le dernier devis ; en cas de doute, écrivez à missions@tribe.sn.";
    case 503: return "Le service de facturation ne répond pas : le devis n'a pas pu être vérifié, rien n'a été signé. Réessayez dans un instant.";
    case 403: return "Votre compte n'a pas accès à ce devis. Reconnectez-vous, ou écrivez à missions@tribe.sn.";
    case 404: return 'Cette mission est introuvable. Rechargez la page.';
    default:  return "La signature n'a pas pu être enregistrée. Réessayez dans quelques minutes.";
  }
}
